<template>
  <div class="mx-3">
    <div>
      <template v-if="!hasServices">
        <FormGroup
          v-if="financials.category"
          title="Category"
        >
          <p>{{ financials.category.descr }}</p>
        </FormGroup>
        <FormGroup title="Scope">
          <pre>{{ financials.scope }}</pre>
        </FormGroup>
      </template>
      <template v-else>
        <div class="font-weight-bold mt-2 mb-2">
          Scope
        </div>
        <table class="mb-2">
          <tr
            v-for="s in services"
            :key="s.id"
          >
            <td class="pr-3 align-top text-nowrap">
              {{ s.count }} x {{ s.service.name }}
            </td>
            <td class="pr-3 align-top">
              ( {{ s.service.descr }} )
              <div
                v-if="s.scope"
                class="rounded-lg bg-gray-200 px-4 py-1 mb-1"
              >
                <CatalogItemInfo
                  :info="s.scope"
                  disable-markdown
                />
              </div>
            </td>
            <td class="pr-3 align-top">
              {{ s.completion }} {{ s.completion ? 'days' : '' }}
            </td>
            <td class="pr-3 text-right align-top">
              {{ formatCurrency(s.price) }}
            </td>
          </tr>
        </table>
      </template>
      <FormGroup title="Price">
        <p>{{ formatCurrency(financials.price) }}</p>
      </FormGroup>
      <p
        v-if="error"
        class="text-danger"
        v-text="error"
      />
    </div>
    <div
      v-if="transitions.length > 0"
    >
      <button
        v-for="tr in transitions"
        :key="tr.dst_state.id"
        class="btn btn-primary mr-2"
        @click="changeStateID(tr)"
      >
        {{ tr.name }}
      </button>
    </div>
    <ConfirmStateChange
      ref="confirmStateChange"
      @state-change="refreshData"
    />
  </div>
</template>

<script>
/**
 * View to show financials for a project.
 */
import FormGroup from '@/components/forms/FormGroup'
import projectAPI from '@/api/project'
import ConfirmStateChange from '@/views/Project/ConfirmStateChange'
import CatalogItemInfo from '@/views/Project/Services/CatalogItemInfo'
import formatCurrency from '@/filters/formatCurrency'

export default {
  components: {
    FormGroup,
    ConfirmStateChange,
    CatalogItemInfo,
  },
  props: {
    /** project */
    project: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      financials: {
        scope: '',
        price: '',
      },
      transitions: [],
      services: [],
      error: '',
    }
  },
  computed: {
    hasServices () {
      return this.services && this.services.length > 0
    },
  },
  beforeMount () {
    this.getData()
  },
  methods: {
    getData () {
      Promise.all([
        projectAPI.getFinancials(this.project.id),
        projectAPI.getProjectTransitions(this.project.id),
        projectAPI.getServices(this.project.id),
      ]).then(([financials, transitions, services]) => {
        this.financials = financials.data
        // get available named transitions that are for quoted stage
        this.transitions = transitions.data.filter(tr => tr.name && tr.src_state.name === 'quoted')
        this.services = services.data
      }).catch(error => {
        this.error = error.message
      })
    },
    refreshData () {
      this.$emit('reload-project')
      this.getData()
    },
    changeStateID (transition) {
      this.$refs.confirmStateChange.toConfirm(transition, this.project.id)
    },
    formatCurrency,
  },
}
</script>

<style scoped>
pre {
  display: inline-block;
  overflow: auto;
  max-width: 100%;
  min-width: 25%;
  min-height: 50px;
  margin-bottom: 0px;
}
</style>
